<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>


    <div id="page-user-list">
    
      <vs-card>
        <div class="vx-row">
    <div class="vx-col w-1/2 mb-2">
          
          <label class="mt-8 text-sm font-bold" for="">Categoria</label>
          <v-select class="mt-2" :options="categoriasDeEmprego" v-model="category"></v-select>
      </div>
      <div class="vx-col w-1/2 mb-2">
          
          <label class="mt-8 text-sm font-bold" for="">Tipo</label>
          <v-select class="mt-2" :options="tiposDeVagasDeEmprego" v-model="type"></v-select>
      </div>
      
    <div class="vx-col w-full mb-2">
        <label class="mt-8 text-sm font-bold" for="">Titulo</label>
        <vs-input class="w-full mt-2 mb-5"  type="text" v-model="title" />
        </div>
        <div class="vx-col w-full mb-2">
        <label class="mt-8 text-sm font-bold" for="">Descrição</label>
        <vs-textarea class="w-full mt-2 mb-5" v-model="description"/>
        </div>

        <div class="vx-col w-1/2 mb-2">
        <label class="mt-8 text-sm font-bold" for="">Email</label>
        <vs-input class="w-full mt-2 mb-5"  type="email" v-model="email" />
        </div>

        <div class="vx-col w-1/2 mb-2">
        <label class="mt-8 text-sm font-bold" for="">Prazo</label>
        <vs-input class="w-full mt-2 mb-5"  type="date" v-model="deadline" />
        </div>
       
        <div class="vx-col w-1/2 mb-2">
        <label class="mt-8 text-sm font-bold" for="">Local</label>
        <vs-input class="w-full mt-2 mb-5"  type="text" v-model="location" />
        </div>
        <div class="vx-col w-1/2 mb-2">
        <label class="mt-8 text-sm font-bold" for="">Documentos necessarios</label>
        <div class="mt-2">
        <vs-checkbox v-model="foreign" vs-value="cv" class="mr-4 ">Curriculo</vs-checkbox>
        <vs-checkbox v-model="foreign" vs-value="cover_letter" class="mr-4 mt-2">Carta de apresentação</vs-checkbox>
        <vs-checkbox v-model="foreign" vs-value="motivation_letter" class="mr-4 mt-2">Carta de Motivação</vs-checkbox>
      </div>
      
        </div>
        <div class="vx-col w-1/2 mb-2">
        <label for="" class="text-sm font-bold">Palavras Chave</label>
       <div class="vx-row" v-for="(input,k) in responsability_names" :key="k">
          <div class="vx-col sm:w-3/4 w-full mb-2">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
               
                icon-no-border
                v-model="input.responsability_name"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2" vs-align="center">
            <div class="vx-col w-full">
              <!-- <span> -->
                  <vs-button
                  icon-pack="feather"
                icon="icon-x"
                  color="danger" 
                 size="small"
                    class="mb-2 mr-2"
                    @click="remove(k)"
                    v-show="k || (!k && responsability_names.length > 1)"
                    ></vs-button
                  >
                  
                  <vs-button
                  icon-pack="feather"
                icon="icon-plus"
                  color="success"
                    class=""
                    size="small"
                    @click="add(k)"
                    v-show="k == responsability_names.length - 1"
                    ></vs-button
                  >
                <!-- </span> -->
            </div>
          </div>
        </div>
        </div>
        <!-- <div class="vx-col w-1/2 mb-2">
          <label class="mt-8 text-sm font-bold" for="">Associar ao teste de personalidade?</label>
          <div class="mt-2">
            <vs-radio v-model="radios1" vs-value="luis">Sim</vs-radio>
          <vs-radio class="ml-2" v-model="radios1" vs-value="luis">Não</vs-radio>
          </div>
       
        </div> -->
        
   <div class="vx-col w-full mb-2">
  <div class="flex flex-wrap items-center flex-start">
        <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
  </div>
        
      </div>
      </div>
  </vs-card>
  
  <vs-popup class="holamundo" title="Actualizar Componente Salarial" :active.sync="popupEdit">
  
       <div class="vx-row">
     <div class="vx-col w-full mb-2">
          
        <label class="mt-8" for="">Tipo de componente</label>
        <select name="Tipo de componente"  v-validate="'required'" v-model="component.type" class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed" 
           >
      <option  value="0">Dedução</option>
      <option  value="1">Remuneração</option>
     
    </select>
     <span class="text-danger text-sm"  v-show="errors.has('Tipo de componente')">{{ errors.first('Tipo de componente') }}</span>
    </div>
           <div class="vx-col w-full mb-2">
            <label class="mt-8" for="">Nome</label>
        <vs-input class="w-full mt-2 mb-5"  type="text" v-model="component.name"   v-validate="'required|alpha_spaces'"
                  name="Nome do componente"/>
         <span class="text-danger text-sm"  v-show="errors.has('Nome')">{{ errors.first('Nome') }}</span>
          </div>
  
          <div class="vx-col w-full mb-2">
        <label class="mt-8" for="">Abreviação</label>
        <vs-input class="w-full mt-2 mb-5"  type="text" v-model="component.abbreviation" />
        </div>
   <div class="vx-col w-full mb-2">
  <div class="flex flex-wrap items-center flex-start">
        <vs-button class="ml-auto mt-2" @click="editData">Actualizar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
  </div>
        
      </div>
      </div>
      </vs-popup>
  
  <vs-popup class="holamundo" title="Adicionar vaga" :active.sync="popupAdd">
  <div class="vx-row">
    <div class="vx-col w-1/2 mb-2">
          
          <label class="mt-8" for="">Categoria</label>
          <v-select :options="categoriasDeEmprego" v-model="category"></v-select>
      </div>
      <div class="vx-col w-1/2 mb-2">
          
          <label class="mt-8" for="">Tipo</label>
          <v-select :options="tiposDeVagasDeEmprego" v-model="type"></v-select>
      </div>

    <div class="vx-col w-full mb-2">
        <label class="mt-8" for="">Titulo</label>
        <vs-input class="w-full mt-2 mb-5"  type="text" v-model="title" />
        </div>
        <div class="vx-col w-full mb-2">
        <label class="mt-8" for="">Descrição</label>
        <vs-input class="w-full mt-2 mb-5"  type="text" v-model="description" />
        </div>

        <div class="vx-col w-1/2 mb-2">
        <label class="mt-8" for="">Email</label>
        <vs-input class="w-full mt-2 mb-5"  type="email" v-model="email" />
        </div>

        <div class="vx-col w-1/2 mb-2">
        <label class="mt-8" for="">Prazo</label>
        <vs-input class="w-full mt-2 mb-5"  type="date" v-model="deadline" />
        </div>
       
        <div class="vx-col w-1/2 mb-2">
        <label class="mt-8" for="">Local</label>
        <vs-input class="w-full mt-2 mb-5"  type="text" v-model="location" />
        </div>
        <div class="vx-col w-full mb-2">
        <label class="mt-8" for="">Documentos necessarios</label>
        <div class="mt-2">
        <vs-checkbox v-model="foreign" vs-value="0" class="mr-4">Curriculo</vs-checkbox>
        <vs-checkbox v-model="foreign" vs-value="1" class="mr-4">Carta de Apresentacao</vs-checkbox>
        <vs-checkbox v-model="foreign" vs-value="1" class="mr-4">Carta de Apresentacao</vs-checkbox>
      </div>
        </div>
        <div class="vx-col w-full mb-2">
        <label for="">Palavras Chave</label>
       <div class="vx-row" v-for="(input,k) in responsability_names" :key="k">
          <div class="vx-col sm:w-3/4 w-full mb-2">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-check"
                icon-no-border
                v-model="input.responsability_name"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/4 w-full mb-2" vs-align="center">
            <div class="vx-col w-full">
              <!-- <span> -->
                  <vs-button
                  color="danger" 
                 
                    class="mb-2"
                    @click="remove(k)"
                    v-show="k || (!k && responsability_names.length > 1)"
                    >-</vs-button
                  >
                  
                  <vs-button
                  color="success"
                    class=""
                    @click="add(k)"
                    v-show="k == responsability_names.length - 1"
                    >+</vs-button
                  >
                <!-- </span> -->
            </div>
          </div>
        </div>
        </div>

        
   <div class="vx-col w-full mb-2">
  <div class="flex flex-wrap items-center flex-start">
        <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
  </div>
        
      </div>
      </div>
      </vs-popup>
    </div>
  
  </template>
  
  <script>
  import vSelect from 'vue-select'
  import http from "../../../../../http-common";
  import { PermissionsMixin } from "../../../../mixins/permissions"
  // Store Module
  
  // Cell Renderer
  
  
  export default {
    mixins:[PermissionsMixin],
    components: {
      vSelect,
  
   
      
    },
    data() {
      return {
        radios1:"",
        foreign:[],
        inputs: [{
        name: '',
        party: ''
      }],
      
      responsability_names: [{
        responsability_name: '',
        
      }],

      responsability:[
  {
    name:"",
    id:"",
  }
],

        popupAdd:false,
        popupEdit:false,
        vagas:[],
        location:"",
        title:"",
        type:"",
        category:"",
        description:"",
        email:"",
        link:"",
        deadline:"",
        key_words:["cv"],
        documents_required:"",
        categoriasDeEmprego : [
  "Tecnologia da Informação (TI)",
  "Saúde e Medicina",
  "Finanças e Contabilidade",
  "Educação",
  "Vendas e Marketing",
  "Recursos Humanos",
  "Engenharia",
  "Serviços de Alimentação",
  "Logística e Transporte",
  "Artes e Entretenimento",
  "Manufatura e Produção",
  "Serviços Profissionais",
  "Construção e Obras",
  "Meio Ambiente e Sustentabilidade",
  "Serviços Públicos e Governo"
],

tiposDeVagasDeEmprego : [
  "Tempo Integral",
  "Meio Período",
  "Temporário/Contrato",
  "Trabalho Remoto",
  "Freelancer/Trabalhador Autônomo",
  "Estágio",
  "Tempo Integral com Período Parcial",
  "Comissionado",
  "Gerência/Supervisão",
  "Consultoria",
  "Educação",
  "Saúde",
  "Tecnologia da Informação (TI)",
  "Artes e Entretenimento",
  "Serviços Públicos e Governo"
],
        component:[
          {
            id:"",
            name:"",
        abbreviation:"",
        type:"",
          }
        ],
        dados:[],
  
  employees:[],
  currentUser:[],
  
  
      }
    },
  
    mounted() {
    },
  
   
    methods: {
  
      
 add () {
      this.responsability_names.push({
        responsability_name: '',
       
      })
      console.log(this.responsability_names)
    },

    remove (index) {
      this.responsability_names.splice(index, 1)
    },
  openConfirm(dados) {
    this.dados=dados
              this.$vs.dialog({
                  type: 'confirm',
                  color: 'danger',
                  title: `Confirmação`,
                  text: 'Tem certeza que deseja eliminar?' ,
                  accept: this.remove
              })
          },
  
  
       getCurrentUser() {
         this.$vs.loading()
        
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
        http
        .get("/auth/me", config)
          .then((success) => {
             this.$vs.loading.close();
            this.currentUser = success.data.User
            
             this.newArray = this.currentUser.permissions.filter(function (el)
  {
    return el.name =="create Employee"
  
  }
  
  );
  
          })
          .catch((error) => {
            error;
  
            
           
          });
      },
  
      getData() {
        
            this.$vs.loading({
          container: '#div-with-loading',
          scale: 1.0,
          type:'sound'
        })
      
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
        
        http
          .get("/recruitments/vacancies", config)
          .then((result) => {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            this.vagas = result.data.data
  // alert("2")
          })
          .catch((error) => {
            error;
             this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            if(error.response.status==401 ){
              this.$router.push('/').catch(() => {})
            }
           
          });
      },
  
             async saveData() {
         
  
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
    
        const data = {
            location:this.location,
        title:this.title,
        type:this.type,
        category:this.category,
        description:this.description,
        email:this.email,
        link:this.link,
        deadline:this.deadline,
        key_words:this.key_words,
        documents_required:this.foreign,
            
        };
  
       http
          .post("/recruitments/vacancies", data, config)
          .then((success) => {
            success;
            this.$router.push('/pages/recrutamento/vagas').catch(() => { })
          
       
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: "Adicionado com sucesso!",
              color: "success",
              position: "top-right",
            })
          })
          .catch((error) => {
            error;
            this.err= error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          });
  
     
      },
  
  
  
  
  
   popupOpenEdit(component){
     this.component=component,
           this.popupEdit=true
  
            
          },
  
             async editData() {
          //      this.$validator.validateAll().then(result => {
          // if (result) {
             this.$vs.loading()
  
  
        let token = localStorage.getItem("token");
        let config = {
          headers: {
            authorization: "Bearer " + token,
          },
        };
    
        const data = {
            name:this.component.name,
            abbreviation:this.component.abbreviation,
            type:this.component.type
            
        };
  
        this.$validator.validateAll();
       http
          .put(`/salaries/components/${this.component.id}`, data, config)
          .then((success) => {
            success;
          this.popupEdit=false,
          
          this.getData(),
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Sucesso",
              text: "Componente salaria actualizado com sucesso!",
              color: "success",
              position: "top-right",
            })
          })
          .catch((error) => {
            error;
            this.err= error.response.data
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          });
          // }})
  
     
      },
  
  
    
     
  
    
  },
  
  }
  
  </script>
  
  